import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
 ListItemButton,
  Link,
  Menu,
  MenuItem,
  Card,
  CardContent,
  Stack
} from '@mui/material';
import {
  Layers,
  ExpandLess,
  InsertDriveFile,
  Description,
  MoreVert,
  Search,
  FileCopy,
  Download,
  Share,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Email,
  WhatsApp,
  Bluetooth,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  PictureAsPdf,
  Engineering 
} from '@mui/icons-material';

// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));


const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const CommuneRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#f5f5f5 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];

// Structure des données hiérarchisées
const masculinityData = {
  title: "Rapport de masculinité de la population des ménages ordinaires par milieu de résidence, province et commune",
  nationalData: {
    total: "12 220 934",
    masculin: "5 823 075",
    feminin: "6 397 859",
    masculinityRatio: "91"
  },
  residenceTypes: [
    {
      name: "URBAIN",
      total: "2 990 471",
      masculin: "1 478 769",
      feminin: "1 511 702",
      masculinityRatio: "98"
    },
    {
      name: "RURAL",
      total: "9 230 473",
      masculin: "4 344 311",
      feminin: "4 886 162",
      masculinityRatio: "89"
    }
  ],
  provinces: [
    {
      name: "BUHUMUZA",
      total: "2 041 416",
      masculin: "978 250",
      feminin: "1 063 166",
      masculinityRatio: "92",
      communes: [
        { name: "BUTAGANZWA", total: "109 714", masculin: "52 537", feminin: "57 177", masculinityRatio: "92" },
        { name: "BUTIHINDA", total: "433 228", masculin: "206 627", feminin: "226 601", masculinityRatio: "91" },
        { name: "CANKUZO", total: "159 901", masculin: "77 469", feminin: "82 432", masculinityRatio: "94" },
        { name: "GISAGARA", total: "290 800", masculin: "139 560", feminin: "151 240", masculinityRatio: "92" },
        { name: "GISURU", total: "336 599", masculin: "161 510", feminin: "175 089", masculinityRatio: "92" },
        { name: "MUYINGA", total: "492 100", masculin: "234 505", feminin: "257 595", masculinityRatio: "91" },
        { name: "RUYIGI", total: "219 074", masculin: "106 042", feminin: "113 032", masculinityRatio: "94" }
      ]
    },
    {
      name: "BUJUMBURA",
      total: "3 311 243",
      masculin: "1 636 670",
      feminin: "1 674 573",
      masculinityRatio: "98",
      communes: [
        { name: "BUBANZA", total: "238 953", masculin: "115 076", feminin: "123 877", masculinityRatio: "93" },
        { name: "BUKINANYANA", total: "268 083", masculin: "129 654", feminin: "138 429", masculinityRatio: "94" },
        { name: "CIBITOKE", total: "259 136", masculin: "126 374", feminin: "132 762", masculinityRatio: "95" },
        { name: "ISARE", total: "149 026", masculin: "70 167", feminin: "78 859", masculinityRatio: "89" },
        { name: "MPANDA", total: "358 910", masculin: "177 081", feminin: "181 829", masculinityRatio: "97" },
        { name: "MUGERE", total: "507 543", masculin: "246 324", feminin: "261 219", masculinityRatio: "94" },
        { name: "MUGINA", total: "224 695", masculin: "109 418", feminin: "115 277", masculinityRatio: "95" },
        { name: "MUHUTA", total: "117 027", masculin: "55 351", feminin: "61 676", masculinityRatio: "90" },
        { name: "MUKAZA", total: "159 166", masculin: "89 472", feminin: "69 694", masculinityRatio: "128" },
        { name: "NTAHANGWA", total: "912 866", masculin: "463 459", feminin: "449 407", masculinityRatio: "103" },
        { name: "RWIBAGA", total: "115 838", masculin: "54 294", feminin: "61 544", masculinityRatio: "88" }
      ]
    },
    {
      name: "BURUNGA",
      total: "2 097 855",
      masculin: "1 001 718",
      feminin: "1 096 137",
      masculinityRatio: "91",
      communes: [
        { name: "BURURI", total: "182 930", masculin: "85 299", feminin: "97 631", masculinityRatio: "87" },
        { name: "MAKAMBA", total: "368 668", masculin: "173 859", feminin: "194 809", masculinityRatio: "89" },
        { name: "MATANA", total: "191 889", masculin: "91 478", feminin: "100 411", masculinityRatio: "91" },
        { name: "MUSONGATI", total: "335 150", masculin: "160 548", feminin: "174 602", masculinityRatio: "92" },
        { name: "NYANZA", total: "366 682", masculin: "177 396", feminin: "189 286", masculinityRatio: "94" },
        { name: "RUMONGE", total: "426 929", masculin: "204 588", feminin: "222 341", masculinityRatio: "92" },
        { name: "RUTANA", total: "225 607", masculin: "108 550", feminin: "117 057", masculinityRatio: "93" }
      ]
    },
    {
      name: "BUTANYERERA",
      total: "2 518 473",
      masculin: "1 180 825",
      feminin: "1 337 648",
      masculinityRatio: "88",
      communes: [
        { name: "BUSONI", total: "357 399", masculin: "169 898", feminin: "187 501", masculinityRatio: "91" },
        { name: "KAYANZA", total: "330 304", masculin: "155 893", feminin: "174 411", masculinityRatio: "89" },
        { name: "KIREMBA", total: "291 246", masculin: "137 322", feminin: "153 924", masculinityRatio: "89" },
        { name: "KIRUNDO", total: "476 758", masculin: "227 182", feminin: "249 576", masculinityRatio: "91" },
        { name: "MATONGO", total: "264 736", masculin: "121 150", feminin: "143 586", masculinityRatio: "84" },
        { name: "MUHANGA", total: "222 657", masculin: "99 623", feminin: "123 034", masculinityRatio: "81" },
        { name: "NGOZI", total: "312 366", masculin: "148 538", feminin: "163 828", masculinityRatio: "91" },
        { name: "TANGARA", total: "263 007", masculin: "121 219", feminin: "141 788", masculinityRatio: "85" }
      ]
    },
    {
      name: "GITEGA",
      total: "2 251 957",
      masculin: "1 025 617",
      feminin: "1 226 340",
      masculinityRatio: "84",
      communes: [
        { name: "BUGENDANA", total: "228 556", masculin: "102 350", feminin: "126 206", masculinityRatio: "81" },
        { name: "GISHUBI", total: "242 753", masculin: "101 206", feminin: "141 547", masculinityRatio: "71" },
        { name: "GITEGA", total: "514 822", masculin: "236 689", feminin: "278 133", masculinityRatio: "85" },
        { name: "KARUSI", total: "376 730", masculin: "177 220", feminin: "199 510", masculinityRatio: "89" },
        { name: "KIGANDA", total: "148 621", masculin: "67 857", feminin: "80 764", masculinityRatio: "84" },
        { name: "MURAMVYA", total: "166 104", masculin: "76 513", feminin: "89 591", masculinityRatio: "85" },
        { name: "MWARO", total: "145 590", masculin: "67 709", feminin: "77 881", masculinityRatio: "87" },
        { name: "NYABIHANGA", total: "175 076", masculin: "78 624", feminin: "96 452", masculinityRatio: "82" },
        { name: "SHOMBO", total: "253 705", masculin: "117 449", feminin: "136 256", masculinityRatio: "86" }
      ]
    }
  ]
};

const MasculinityRatioPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [expandedProvinces, setExpandedProvinces] = useState({});
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  
  const handleCopyTable = () => {
    let tableContent = "Zone\tTotal\tMasculin\tFéminin\tRapport M/F\n";
    
    // Ajout des données nationales
    tableContent += `BURUNDI\t${masculinityData.nationalData.total}\t${masculinityData.nationalData.masculin}\t${masculinityData.nationalData.feminin}\t${masculinityData.nationalData.masculinityRatio}\n`;
    
    // Ajout des données par milieu de résidence
    masculinityData.residenceTypes.forEach(residence => {
      tableContent += `  ${residence.name}\t${residence.total}\t${residence.masculin}\t${residence.feminin}\t${residence.masculinityRatio}\n`;
    });
    
    // Ajout des données par province et commune
    masculinityData.provinces.forEach(province => {
      tableContent += `${province.name}\t${province.total}\t${province.masculin}\t${province.feminin}\t${province.masculinityRatio}\n`;
      
      province.communes.forEach(commune => {
        tableContent += `  ${commune.name}\t${commune.total}\t${commune.masculin}\t${commune.feminin}\t${commune.masculinityRatio}\n`;
      });
    });
    
    navigator.clipboard.writeText(`${masculinityData.title}\n\n${tableContent}`)
      .then(() => alert('Tableau copié dans le presse-papier'))
      .catch(err => console.error('Erreur lors de la copie:', err));
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleProvince = (provinceName) => {
    setExpandedProvinces(prev => ({
      ...prev,
      [provinceName]: !prev[provinceName]
    }));
  };

  const handleShareMenuOpen = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleDownloadMenuOpen = (event) => {
    setDownloadAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setShareAnchorEl(null);
    setDownloadAnchorEl(null);
  };

  const shareVia = (method) => {
    handleMenuClose();
    const text = `Découvrez les données sur le rapport de masculinité au Burundi: ${masculinityData.title}`;
    const url = window.location.href;
    
    switch(method) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
        break;
      case 'email':
        window.open(`mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'bluetooth':
        alert(`Partage via Bluetooth simulé: ${text}`);
        break;
      default:
        if (navigator.share) {
          navigator.share({
            title: text,
            url: url
          }).catch(err => console.log('Erreur de partage:', err));
        } else {
          navigator.clipboard.writeText(url);
          alert('Lien copié dans le presse-papier');
        }
    }
  };

  const downloadFile = (format) => {
    handleMenuClose();
    const blob = new Blob([JSON.stringify(masculinityData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `rapport-masculinite-burundi.${format}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    alert(`Téléchargement du fichier ${format} simulé`);
  };

  // Calcul des indicateurs clés
  const keyStats = {
    totalPopulation: masculinityData.nationalData.total,
    urbanRatio: masculinityData.residenceTypes.find(r => r.name === "URBAIN").masculinityRatio,
    ruralRatio: masculinityData.residenceTypes.find(r => r.name === "RURAL").masculinityRatio,

    highestRatioProvince: masculinityData.provinces.reduce((max, province) => 
      parseInt(province.masculinityRatio) > parseInt(max.masculinityRatio) ? province : max
    ),

    lowestRatioProvince: masculinityData.provinces.reduce((min, province) => 
      parseInt(province.masculinityRatio) < parseInt(min.masculinityRatio) ? province : min
    ),

    highestRatioCommune: masculinityData.provinces.flatMap(p => p.communes).reduce((max, commune) => 
      parseInt(commune.masculinityRatio) > parseInt(max.masculinityRatio) ? commune : max
    ),

    lowestRatioCommune: masculinityData.provinces.flatMap(p => p.communes).reduce((min, commune) => 
      parseInt(commune.masculinityRatio) < parseInt(min.masculinityRatio) ? commune : min
    )
  };

  const filteredProvinces = masculinityData.provinces.map(province => {
    if (!searchTerm) return province;
    
    const filteredCommunes = province.communes.filter(commune =>
      commune.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    return {
      ...province,
      communes: filteredCommunes,
      show: filteredCommunes.length > 0 || 
            province.name.toLowerCase().includes(searchTerm.toLowerCase())
    };
  }).filter(province => province.show || !searchTerm);

 
   // Composant du menu latéral
   const drawer = (
     <div>
       {isMobile && (
         <MobileDrawerHeader>
           <IconButton onClick={handleDrawerToggle}>
             <Close color="primary" />
           </IconButton>
         </MobileDrawerHeader>
       )}
       <Divider />
       <List>
         {menuItems.map((item) => (
           <ListItem key={item.text} disablePadding>
             <ListItemButton
               component={Link}
               to={item.to}
               onClick={isMobile ? handleDrawerToggle : undefined}
             >
               <ListItemIcon>{item.icon}</ListItemIcon>
               <ListItemText primary={item.text} />
             </ListItemButton>
           </ListItem>
         ))}
       </List>
     </div>
   );
 

  return (
  <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            {drawer}
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {masculinityData.title}
                    </Typography>
                  </Box>
                     <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                          <Grid item xs={12} sm={6} md={6} ></Grid>
                          <Grid item xs={12} sm={6} md={6}>
                            <TextField
                      size="small"
                      placeholder="Rechercher province/commune..."
                      variant="outlined"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ width: { xs: '100%', sm: '480px' } }}
                    />
                    </Grid>
                    </Grid>
                  
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés du Rapport de Masculinité
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population Totale
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {masculinityData.nationalData.total}
                              </Typography>
                              <Typography variant="caption">
                                Habitants
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Rapport National
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {masculinityData.nationalData.masculinityRatio}
                              </Typography>
                              <Typography variant="caption">
                                hommes pour 100 femmes
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Plus haut rapport
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.highestRatioCommune.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.highestRatioCommune.masculinityRatio}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  (Province: {masculinityData.provinces.find(p => p.communes.some(c => c.name === keyStats.highestRatioCommune.name))?.name})
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Plus bas rapport
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.lowestRatioCommune.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.lowestRatioCommune.masculinityRatio}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                (Province: {masculinityData.provinces.find(p => p.communes.some(c => c.name === keyStats.lowestRatioCommune.name))?.name})
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Zone</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell align="right">Masculin</TableCell>
                          <TableCell align="right">Féminin</TableCell>
                          <TableCell align="right">Rapport M/F</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Ligne pour le total Burundi */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                            BURUNDI
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{masculinityData.nationalData.total}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{masculinityData.nationalData.masculin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{masculinityData.nationalData.feminin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{masculinityData.nationalData.masculinityRatio}</TableCell>
                        </ProvinceRow>

                        {/* Données par milieu de résidence */}
                        {masculinityData.residenceTypes.map((residence, idx) => (
                          <CommuneRow key={idx} hover>
                            <TableCell sx={{ pl: 4 }}>{residence.name}</TableCell>
                            <TableCell align="right">{residence.total}</TableCell>
                            <TableCell align="right">{residence.masculin}</TableCell>
                            <TableCell align="right">{residence.feminin}</TableCell>
                            <TableCell align="right">{residence.masculinityRatio}</TableCell>
                          </CommuneRow>
                        ))}

                        {/* Données par province et commune */}
                        {filteredProvinces.map((province, index) => (
                          <React.Fragment key={index}>
                            <ProvinceRow 
                              hover 
                              onClick={() => toggleProvince(province.name)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedProvinces[province.name] ? <ExpandLess /> : <ExpandMore />}
                                  {province.name}
                                </Box>
                              </TableCell>
                              <TableCell align="right">{province.total}</TableCell>
                              <TableCell align="right">{province.masculin}</TableCell>
                              <TableCell align="right">{province.feminin}</TableCell>
                              <TableCell align="right">{province.masculinityRatio}</TableCell>
                            </ProvinceRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={5}>
                                <Collapse in={expandedProvinces[province.name] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {province.communes.map((commune, idx) => (
                                        <CommuneRow key={idx} hover>
                                          <TableCell sx={{ pl: 6 }}>{commune.name}</TableCell>
                                          <TableCell align="right">{commune.total}</TableCell>
                                          <TableCell align="right">{commune.masculin}</TableCell>
                                          <TableCell align="right">{commune.feminin}</TableCell>
                                          <TableCell align="right">{commune.masculinityRatio}</TableCell>
                                        </CommuneRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                         {/* 
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Tooltip title="Copier le tableau">
                      <IconButton onClick={handleCopyTable} sx={{ color: primaryColor }}>
                        <FileCopy />
                      </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Télécharger les données">
                      <IconButton 
                        onClick={handleDownloadMenuOpen}
                        sx={{ color: secondaryColor }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={downloadAnchorEl}
                      open={Boolean(downloadAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => downloadFile('xlsx')}>
                        <ListItemIcon>
                          <InsertDriveFile fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excel (.xlsx)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('csv')}>
                        <ListItemIcon>
                          <Description fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>CSV (.csv)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('pdf')}>
                        <ListItemIcon>
                          <PictureAsPdf fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>PDF (.pdf)</ListItemText>
                      </MenuItem>
                    </Menu>
                    
                    <Tooltip title="Partager">
                      <IconButton 
                        onClick={handleShareMenuOpen}
                        sx={{ color: primaryColor }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={shareAnchorEl}
                      open={Boolean(shareAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => shareVia('whatsapp')}>
                        <ListItemIcon>
                          <WhatsApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>WhatsApp</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('email')}>
                        <ListItemIcon>
                          <Email fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Email</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('bluetooth')}>
                        <ListItemIcon>
                          <Bluetooth fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Bluetooth</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('other')}>
                        <ListItemIcon>
                          <MoreVert fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Autre méthode</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
*/}

                </Paper>
                
                {/* Section d'information */}
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      À propos du rapport de masculinité
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      Le rapport de masculinité est un indicateur démographique qui mesure le nombre d'hommes pour 100 femmes dans une population donnée. 
                      Il est calculé comme suit : (Nombre d'hommes / Nombre de femmes) × 100.
                    </Typography>
                    <Typography variant="body2" paragraph>
                      Interprétation du rapport de masculinité :
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      <ListItem>
                        <ListItemText 
                          primary="• Supérieur à 100 : plus d'hommes que de femmes" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Inférieur à 100 : plus de femmes que d'hommes" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Égal à 100 : égalité parfaite entre les sexes" 
                        />
                      </ListItem>
                    </List>
                    <Typography variant="body2" mt={2}>
                      Au niveau national, le Burundi présente un rapport de masculinité de {masculinityData.nationalData.masculinityRatio}, 
                      ce qui signifie qu'il y a environ {masculinityData.nationalData.masculinityRatio} hommes pour 100 femmes dans le pays.
                    </Typography>
                 
                                        </AccordionDetails>
                                      </Accordion>
                                      
                                      {/* Notes méthodologiques */}
                                      <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                                        <Typography variant="subtitle2" gutterBottom color="primary">
                                          Notes méthodologiques
                                        </Typography>
                                          <Typography variant="body2" color="text.secondary">
                                              Les données présentées sont issues du Recensement Général de la Population, de l'Habitat, de l'Agriculture et Elevage (RGPHAE)
                                              réalisé en 2024. Les chiffres incluent toute la population résidente du Burundi. Les pourcentages sont calculés par rapport
                                               au total de chaque ligne (province ou commune). Le rapport de masculinité est calculé comme (Nombre d'hommes / Nombre de femmes) * 100.
                                         </Typography>
                                      </Paper>
                                    </Grid>
                                  </Grid>
                                </Container>
                              </ContentWrapper>
                            </MainContentWithDrawer>
                            <Footer />
                          </MainContainer>
                        );
                      };
                      
                      export default MasculinityRatioPage;